import { type ReactNode } from 'react';

import styles from './TagGroup.module.css';

export function TagIcon(props: { children: ReactNode }) {
  return <span {...props} className={styles.icon} />;
}
